import React from "react";
import { FaFileAlt, FaPen } from "react-icons/fa";
import {
  FREQUENCIES,
  scheduleSummary,
  sectionsLabel,
  anyFrequencyEnabled,
} from "./autoReportConfig";

/**
 * Firma bilgi sekmesindeki "Rapor Ayarları" bölümü — diğer bölümlerle aynı
 * kabuk (beyaz kart, renkli ikonlu büyük harf başlık). Her frekans tek satır
 * özet; düzenleme sağ üstteki butondan çekmecede yapılır.
 */
export default function FirmReportSettingsBox({ firm, onOpen }) {
  const cfg = firm?.autoReportMailConfig;
  const anyEnabled = anyFrequencyEnabled(cfg);

  return (
    <section className="bg-white rounded-xl sm:rounded-2xl shadow-sm border border-gray-200 p-4 sm:p-5">
      <div className="flex items-center justify-between gap-2 mb-3">
        <div className="flex items-center gap-2 min-w-0">
          <FaFileAlt className="text-indigo-500 w-4 h-4 shrink-0" />
          <h3 className="text-[13px] font-bold text-gray-700 uppercase tracking-wide">Rapor Ayarları</h3>
          <span
            className={`px-2 py-0.5 rounded-full text-[11px] font-SemiBold ${
              anyEnabled ? "bg-sixth/10 text-sixth" : "bg-gray-100 text-gray-500"
            }`}
          >
            {anyEnabled ? "Açık" : "Kapalı"}
          </span>
        </div>
        <button
          type="button"
          onClick={onOpen}
          className="inline-flex items-center gap-1.5 px-3 py-1.5 text-xs font-SemiBold text-main bg-white border border-gray-200 rounded-lg hover:border-main transition-colors shrink-0"
        >
          <FaPen className="w-2.5 h-2.5" />
          Düzenle
        </button>
      </div>

      <div className="divide-y divide-gray-100">
        {FREQUENCIES.map(({ key, label }) => {
          const item = cfg?.[key];
          const enabled = !!item?.enabled;
          return (
            <div key={key} className="flex items-center gap-3 py-2">
              <span className={`w-2 h-2 rounded-full shrink-0 ${enabled ? "bg-sixth" : "bg-gray-300"}`} />
              <span className={`w-16 text-sm font-SemiBold shrink-0 ${enabled ? "text-gray-800" : "text-gray-400"}`}>
                {label}
              </span>
              {enabled ? (
                <span className="flex-1 min-w-0 text-sm text-gray-600 truncate">
                  {scheduleSummary(key, item)}
                  <span className="text-gray-400"> · {sectionsLabel(item)}</span>
                </span>
              ) : (
                <span className="flex-1 text-sm text-gray-400">Kapalı</span>
              )}
            </div>
          );
        })}
      </div>
    </section>
  );
}
